var initializeBrick = (function() {
  var articleId;
  var blogId;
  var colorsData = {};
  var designData;
  function initializeBrick(_articleId, _blogId, _designData) {
    articleId = _articleId;
    blogId = _blogId;
    designData = _designData;
    getColorData();
  }

  function getColorData() {
    var request = $.ajax({
      type: 'GET',
      url: 'https://apps.joltteam.com/internal/brikbuild/colors?DEV=2',
    });

    request.done(function(result) {
      $.each(result, function(_, brikPack) {
        colorsData[parseInt(brikPack.id)] = {
          image: brikPack.variants[25].image,
          name: brikPack.name,
        };
      });
      startLoading();
    });

    request.fail(function(jqXHR, textStatus) {
      console.log('Error from server, httpStatus:' + jqXHR.status +
        ' message:' + jqXHR.responseText + ';' + textStatus);
    });
  }

  function startLoading() {
    $(document).ready(populate1x1BrikImages);
    var otherDesignsLoader = new SuggestedDesigns(
      '#other-designs',
      '/internal/brikbuild/other-designs',
      articleId,
      blogId
    );
    otherDesignsLoader.load();
    var similarDesignsLoader = new SuggestedDesigns(
      '#similar-designs',
      '/internal/brikbuild/similar-designs',
      articleId,
      blogId,
      similarDesignsHandler
    );
    similarDesignsLoader.load();
  }

  function similarDesignsHandler(response) {
    if (response.isSimilarArticles) {
      return;
    }
    $('.suggested-designs-header', '#similar-designs').hide();
    $('.suggested-designs-alternative-header', '#similar-designs').show();
  }

  function populate1x1BrikImages() {
    if (!$('#more-view-carousel').data('owlCarousel')) {
      $('#more-view-carousel').append(
        $.map(designData.briks, function(_, brikId) {
          return constructThumbnail(brikId);
        })
      );
    } else {
      $.each(designData.briks, function(brikId) {
        $('#more-view-carousel').data('owlCarousel').addItem(
          constructThumbnail(brikId)
        );
      });
    }
  }

  function constructThumbnail(brikId) {
    var colorData = colorsData[brikId];
    var li = $('<li class="grid-item"></li>');
    var a = $('<a href="javascript:void(0)"></a>')
      .data('image', colorData.image)
      .data('zoomImage', colorData.image);
    a.append($('<img class="img-100">').attr('src', colorData.image).attr('alt', colorData.name));
    li.append(a);
    return li;
  }

  return initializeBrick;
}());
